import script from "./Clients.vue?vue&type=script&setup=true&lang=js"
export * from "./Clients.vue?vue&type=script&setup=true&lang=js"

import "./Clients.vue?vue&type=style&index=0&id=3b656996&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b656996"]])

export default __exports__